(function () {
    'use strict';

    var app = angular.module('iMatApp', ['ngAnimate', 'ngFileUpload', 'ngSanitize', 'ui.bootstrap', 'pascalprecht.translate', "emguo.poller", 'angularUUID2', 'underscore', 'ui.select', 'ui.knob', 'LocalStorageModule']);

    app.config(['$translateProvider', '$logProvider', 'pollerConfig', 'localStorageServiceProvider',
        function ($translateProvider, $logProvider, pollerConfig, localStorageServiceProvider) {
        $translateProvider.useSanitizeValueStrategy('sanitize');
        $translateProvider.preferredLanguage('current');

        $logProvider.debugEnabled(false);

        pollerConfig.neverOverwrite = true;

        localStorageServiceProvider.setPrefix('MultipleUpload');
        localStorageServiceProvider.setStorageType('localStorage');
        localStorageServiceProvider.setDefaultToCookie(false);
        localStorageServiceProvider.setNotify(false, false);

    }]);

})();